<div class="grid" *ngIf="cargando">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!cargando">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'CONFIGURACIONCANALESESTADO.LBL_CONFIGCANALESTADO' | translate}}">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONFIGURACIONCANALESESTADO.LBL_CANAL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{canalSeleccionada.canal}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONFIGURACIONCANALESESTADO.LBL_ESTADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canalSeleccionada.estado}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONFIGURACIONCANALESESTADO.LBL_SECCION' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canalSeleccionada.seccion}}</strong></label>

          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CONFIGURACIONCANALESESTADO.LBL_CONTROL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canalSeleccionada.control}}</strong></label>
        </div>

        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canalSeleccionada.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>


      </p-panel>
      <p-panel header="{{ 'CONFIGURACIONCANALESESTADO.LBL_SELECCIONPASOS' | translate}}">
        <app-canal-estado-paso *ngIf="canalSeleccionada" [configuracionCanal]="canalSeleccionada" [editar]="false"></app-canal-estado-paso>
      </p-panel>
    </div>
  </div>


  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>

